import { TokenUser } from '../models/token-user';

export class User extends TokenUser {
    id?: number;
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    mentorId?: number;
    representativeId?: number;
    appUserId?: number;

    mentorName!: string;
    representativeName!: string;
    token?: string;
}